/* eslint-disable no-console */
import rules from '../../constants/businessRules/businessRules';
import isTestingEnvironment from '../isTestingEnvironment';
import emitter from './emitter';
import {
    emitOnMount,
    emitOnNotification,
    emitOnError,
    emitOnSave,
    emitOnSaveAsTemplate,
    emitOnSaveBlock,
    emitOnSendTest,
    emitOnChangesExist,
    emitOnPersonalizationEdit,
    emitOnPersonalizationDownloadCsv,
    emitOnGetSingleUseTagData,
} from './invokeCallbacks';

export default {
    sendMounted: emitOnMount,
    sendIframeReady: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENTS.IFRAME_READY);
    },
    triggerAutoSave: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENT_TRIGGERS.TRIGGER_AUTO_SAVE);
    },
    triggerSave: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENT_TRIGGERS.TRIGGER_SAVE);
    },
    notify: (msg, isError) => {
        const payload = String(msg);
        if (isTestingEnvironment()) {
            const message = isError ? `ERROR:\n${msg}` : `NOTIFICATION:\n${msg}`;
            console.error(message);
            return;
        }
        if (isError) {
            console.log(`__PIKASSO__\n__UNEXPECTED ERROR HAPPENED__\n${payload}`);
            emitOnError(payload);
            return;
        }
        emitOnNotification(payload);
    },
    updateChangesExistStatus: (status) => {
        emitOnChangesExist(status);
    },
    personalizationEdit: () => {
        emitOnPersonalizationEdit();
    },
    personalizationDownloadCsv: () => {
        emitOnPersonalizationDownloadCsv();
    },
    // TODO: change this function signature, three iframe messages are using the same function
    sendHtml: (html, purpose, blocks = '[]', pendingSaveId = undefined) => {
        if (isTestingEnvironment()) {
            console.log(`${purpose} successful.`);
            return;
        }
        switch (purpose) {
            case 'save':
                emitOnSave(pendingSaveId ? { html, blocks, pendingSaveId } : { html, blocks });
                return;
            case 'saveAsTemplate':
                emitOnSaveAsTemplate({ html, blocks });
                return;
            case 'sendTest':
                emitOnSendTest(html);
                break;
            default:
        }
    },
    saveBlock: (blockData) => {
        if (isTestingEnvironment()) {
            console.log(blockData);
            return;
        }
        emitOnSaveBlock(blockData);
    },
    shareDraft: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENTS.SHARE_DRAFT);
    },
    leaveDraft: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENTS.LEAVE_DRAFT);
    },
    removeAllListeners: () => {
        emitter.removeAllListeners();
    },
    getSingleUseTagData: () => {
        emitOnGetSingleUseTagData();
    },
    // Another connected client saved the document.
    sendRemoteSaved: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENTS.REMOTE_SAVED);
    },
    sendLiveSyncLost: () => {
        emitter.emit(rules.EVENT_EMITTER_EVENTS.LIVE_SYNC_LOST);
    },
};
